import React, {useEffect, useState} from 'react';
import HomeStatCard from "./HomeStatCard";
import {Eye, Plus, Upload, Video} from "lucide-react";
import HomeCard from "./HomeCard";
import HomeQuickAction from "./HomeQuickAction";
import {ACTION_SERIES, CREATE_SERIES, GET_ACTIVE_SERIES, GET_SHORTS_GENERATED} from "../../route";
import HomeActiveSeries from "./HomeActiveSeries";
import {toast} from "react-toastify";
import HomeLinkAccountsCard from "./HomeLinkAccountsCard";
import authApi from "../../auth.api";

const HomeHomeContent = () => {
    const [shortsGenerated, setShortsGenerated] = useState(0);
    const [activeSeries, setActiveSeries] = useState([]);
    const fetchActiveSeries = async () => {
        const {data} = await authApi.get(GET_ACTIVE_SERIES);
        setActiveSeries(data.series);
    };
    useEffect(() => {
        const fetchShortsGenerated = async () => {
            try {
                const {data} = await authApi.get(GET_SHORTS_GENERATED,);
                setShortsGenerated(data.count);
            } catch (error) {
                toast.error('Failed to load shorts. Please try again.');
            }
        };
        fetchShortsGenerated();
        fetchActiveSeries()
    }, []);
    const handleSeriesAction = async (id) => {
        await authApi.put(`${ACTION_SERIES}pause/${id}`);
        toast.success('series paused')
        fetchActiveSeries()
    };
    return (
        <div className="space-y-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <HomeStatCard title="Active Series" value={activeSeries.length} icon={Eye} trend={2.5}/>
                <HomeStatCard title="Shorts Generated" value={shortsGenerated} icon={Video} trend={-1.8}/>
                {/*<HomeStatCard title="Total Views" value="10,534" icon={PieChart} trend={5.7} />*/}
                {/*<HomeStatCard title="Engagement Rate" value="8.7%" icon={CheckCircle} trend={0.3} />*/}
            </div>
            <HomeCard>
                <h3 className="text-2xl font-semibold mb-6 text-gray-800">Quick Actions</h3>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                    <HomeQuickAction
                        icon={Plus}
                        title="Create New Series"
                        description="Start a new AI-generated series"
                        link={CREATE_SERIES}
                    />
                    <HomeLinkAccountsCard/>
                    <HomeQuickAction
                        icon={Upload}
                        title="Publish Short"
                        description="Share your latest creation"
                    />
                    {/*<QuickActionCard*/}
                    {/*    icon={BarChart2}*/}
                    {/*    title="View Analytics"*/}
                    {/*    description="Check your performance metrics"*/}
                    {/*/>*/}
                </div>
            </HomeCard>
            {activeSeries.length>0 &&<HomeActiveSeries activeSeries={activeSeries} handleSeriesAction={handleSeriesAction}/>}
        </div>
    );
};

export default HomeHomeContent;
